import { Box } from "@mui/material";
import { LayoutFlex } from "../../components/NewLayout";
import {
  DESCARGA_CENTERS,
  DESCARGA_REASONS,
} from "../../utils/descarga";
import { FormProvider } from "./FormContext";
import FormNewOrder from "./FormNewOrder";

export { DESCARGA_CENTERS, DESCARGA_REASONS };

export const reasons = [
  "1 - Carregamento Oliveira Energia ",
  "2 - Carregamento CIF - Posto",
  "3 - Carregamento CIF - Usina",
  "4 - Carregamento FOB",
  "5 - Abastecimento Consumo Interno - Geradores",
  "6 - Abastecimento Consumo Interno - Motor de combate a incêndio",
  "7 - Abastecimento - Outros",
  "8 - Complemento de carregamento CIF",
  "9 - Complemento de carregamento FOB",
  "10 - Complemento de descarga",
  "11 - Erro Ticket - Sem retorno do painel",
  "12 - Erro Ticket - Lado da plataforma de carregamento",
  "13 - Carregamento Armazenagem REAM",
  "14 - Outros",
  "15 - Descarga",
  "16 - Descarga Retorno Abertura de Espaço",
];

export const NewOrderPage: React.FC = () => {
  return (
    <LayoutFlex>
      <Box sx={{ padding: "1.6rem 8rem", height: "100%" }}>
        <FormProvider>
          <FormNewOrder />
        </FormProvider>
      </Box>
    </LayoutFlex>
  );
};
